<router-outlet></router-outlet>
<ngx-ui-loader></ngx-ui-loader>
<app-footer (sendMessage)="sendMessage($event)"></app-footer>
<app-animated-loader></app-animated-loader>
